import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/organisations/donation@2x.jpg")